import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import {
   Input, Tabs, Table, Typography, Space, Tooltip, Button,
   Empty, Skeleton, Tag
} from 'antd';
import ResponsiveBreadcrumb from '../../components/breadcrumb/ResponsiveBreadcrumb';
import { BookOutlined, CalendarOutlined, ClockCircleOutlined, DatabaseOutlined, EyeOutlined, FormOutlined, HistoryOutlined, SearchOutlined } from '@ant-design/icons';
// import NoticeBoard from '../../components/notice-board/NoticeBoard';
import Highlighter from 'react-highlight-words';
import axios from 'axios';

import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
import { useDispatch } from 'react-redux';
import { reset_mastery_data, set_mastery_assignment, reset_mastery_assignment_data } from '../../actions';
import NoticeBoardSlide from '../../components/notice-board/NoticeBoardSlide';
import '../common/BraineeModule.css';

const { TabPane } = Tabs;
const { Text } = Typography;

export function MasteryStudentAssessment() {
   const navigate = useNavigate();
   const location = useLocation();
   const dispatch = useDispatch();

   const aTab = location.state !== null ? location.state.activetab : "1";

   const [searchText, setSearchText] = React.useState("");
   const [searchedColumn, setSearchedColumn] = React.useState("");
   const [currentList, setCurrentList] = useState([]);
   const [upcomingList, setUpcomingList] = useState([]);
   const [pastList, setPastList] = useState([]);
   const [activeTab, setActiveTab] = useState(aTab);
   const [listLoading, setListLoading] = useState(true);
   const [assignedSubjects, setAssignedSubjects] = useState(null);
   const [subject, setSubject] = useState(0);
   // const [masteryList, setMasteryList] = useState([]);

   const user_id = Utils.getCurrentUserInfo(Enums.UserInfo.id);

   useEffect(() => {
      Utils.verifyJwt();

      // const unloadCallback = (event) => {
      // //   event.preventDefault();
      // //   event.returnValue = "";
      // // localStorage.clear();
      //   return "";
      // };

      // window.addEventListener("beforeunload", unloadCallback);
      // return () => window.removeEventListener("beforeunload", unloadCallback);

      // axios.get(`${process.env.REACT_APP_API_STUDENT_MASTERY_ASSESSMENT}/masterysubjectassignments?student_id=${user_id}&time_tense=1`).then((response) => {
      //    console.log(response);

      //    if (response.data) {
      //       const data = response.data;

      //       setAssignedSubjects(data);
      //    }
      // }, (error) => {
      //    console.log(error.message);
      // });

      getSubjectCounts(user_id, aTab);

      setActiveTab(() => {
         // refreshList(aTab);
         getMasteryList(user_id, 0, aTab);
         return aTab
      });
   }, []);

   const getSubjectCounts = (student_id, time_tense) => {
      axios.get(`${process.env.REACT_APP_API_STUDENT_MASTERY_ASSESSMENT}/masterysubjectassignments?student_id=${student_id}&time_tense=${time_tense}`).then((response) => {
         console.log(response);

         if (response.data) {
            const data = response.data;

            setAssignedSubjects(data);
         }
      }, (error) => {
         console.log(error.message);
      });
   }

   const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
   };

   const handleReset = clearFilters => {
      clearFilters();
      setSearchText("");
   };

   const getColumnSearchProps = dataIndex => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
         <div style={{ padding: 8 }}>
            <Input
               ref={node => {
                  //this.searchInput(node);
               }}
               placeholder={`Search ${dataIndex}`}
               value={selectedKeys[0]}
               onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
               onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
               style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Space>
               <Button
                  type="primary"
                  onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                  icon={<SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}>
                  Search
               </Button>
               <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                  Reset
               </Button>
               <Button
                  type="link"
                  size="small"
                  onClick={() => {
                     confirm({ closeDropdown: false });
                     setSearchText(selectedKeys[0]);
                     setSearchedColumn(dataIndex);
                  }}
               >
                  Filter
               </Button>
            </Space>
         </div>
      ),
      filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#033D89' : undefined }} />,
      onFilter: (value, record) =>
         record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
      // onFilterDropdownVisibleChange: visible => {
      //    if (visible) {
      //       setTimeout(() => this.searchInput.select(), 100);
      //    }
      // },
      render: text =>
         searchedColumn === dataIndex ? (
            <Highlighter
               highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
               searchWords={[searchText]}
               autoEscape
               textToHighlight={text ? text.toString() : ''}
            />
         ) : (
            text
         ),
   });

   const assigned_ass_columns = [
      {
         title: 'Id',
         key: 'id',
         dataIndex: 'id',
         hidden: true,
      },
      {
         title: 'Allow',
         key: 'allow_result_viewing',
         dataIndex: 'allow_result_viewing',
         hidden: true,
      },

      {
         title: 'Assessment Id',
         key: 'mastery_assessment_id',
         dataIndex: 'mastery_assessment_id',
         hidden: true,
      },
      {
         title: 'Start Date',
         key: 'start_date',
         dataIndex: 'start_date',
         hidden: true,
      },
      {
         title: 'End Date',
         key: 'end_date',
         dataIndex: 'end_date',
         hidden: true,
      },
      {
         title: 'Term',
         dataIndex: 'term',
         key: 'term',
         width: '9%'
      },
      {
         title: 'Subject',
         key: 'subject_desc',
         ...getColumnSearchProps('subject_desc'),
         ellipsis: {
            showTitle: true,
         },
         render: object => (
            <Tooltip placement="topLeft" title={object.subject_desc}>
               <Text>{object.subject_desc}</Text>
            </Tooltip>
         ),
         width: '12%'
      },
      {
         title: 'Code',
         key: 'competency',
         ...getColumnSearchProps('competency'),
         ellipsis: {
            showTitle: true,
         },
         render: object => (
            <Tooltip placement="topLeft" title={object.competency}>
               <Text>{object.competency}</Text>
            </Tooltip>
         ),
         width: '7%'
      },
      {
         title: 'Competency Title',
         key: 'title',
         ...getColumnSearchProps('title'),
         ellipsis: {
            showTitle: true,
         },
         render: object => (
            <Tooltip placement="topLeft"
               title={
                  <>
                     <b>{object.title}</b>
                     <p>{object.start_date + ' - ' + object.end_date}</p>
                  </>
               }
            >
               <div style={{ width: "100%", cursor: "default" }}>
                  <b><Text>{object.title}</Text></b>
                  <p style={{ marginBottom: '0px' }}>{object.start_date + ' - ' + object.end_date}</p>
               </div>
            </Tooltip>
         ),
         width: '28%'
      },

      {
         title: 'Type',
         dataIndex: 'assessment_type',
         key: 'assessment_type',
         width: '7%'
      },
      {
         title: 'Assigned By',
         key: 'assigned_by',
         ...getColumnSearchProps('assigned_by'),
         ellipsis: {
            showTitle: true,
         },
         render: object => (
            <Tooltip placement="topLeft" title={object.assigned_by}>
               <Text>{object.assigned_by}</Text>
            </Tooltip>
         ),
         width: '12%'
      },
      {
         title: 'Status',
         key: 'status',
         ...getColumnSearchProps('status'),
         ellipsis: {
            showTitle: true,
         },
         render: object => (
            <>
               {/* {object.status === 'Completed' || object.status === 'Incomplete' &&
               // <Tag color={object.status === 'Completed' ? "green" : "red"}>{object.status}</Tag>
               <Tag>{object.status}</Tag>
            } */}
               {object.status === 'Completed'
                  ?
                  <Tag color={"green"}>{object.status}</Tag>
                  :
                  <>
                     {object.status === 'Not Started'
                        ?
                        <Tag color={"red"}>{object.status}</Tag>
                        :
                        <Tag color={"gold"}>{object.status}</Tag>
                     }
                  </>
               }
            </>
         ),
         width: '10%'
      },
      {
         title: 'Action',
         key: 'action',
         render: payload => {
            return <>
               <Space size="small">

                  {activeTab === '1' &&
                     <>
                        {payload.status === 'Incomplete' || payload.status === 'Not Started'
                           ?
                           <Tooltip placement="top" title='Take Mastery'>
                              <FormOutlined color='#033D89' style={{ cursor: 'pointer' }} onClick={() => handleShowMastery(payload.id, payload.mastery_assessment_id)} />
                           </Tooltip>
                           :
                           <Tooltip placement="top" title='View Mastery Result'>
                              <EyeOutlined
                                 color='#033D89'
                                 style={{ cursor: 'pointer' }}
                                 onClick={() => handleShowMastery(payload.id, payload.mastery_assessment_id)}
                              />
                           </Tooltip>
                        }
                     </>
                  }
                  {activeTab === '3' &&
                     <Tooltip
                        placement="top"
                        title='View Mastery Result'
                     >
                        <EyeOutlined
                           color='#033D89'
                           style={{ cursor: 'pointer' }}
                           // onClick={() => handleViewAnswer(payload.id, payload.mastery_assessment_id, payload.question_type, activeTab, payload.attempts, payload.allow_result_viewing)}
                           onClick={() => payload.status === "Completed" ? handleShowMastery(payload.id, payload.mastery_assessment_id) : handleViewAnswer(payload.id, payload.mastery_assessment_id, payload.question_type, activeTab, payload.attempts, payload.allow_result_viewing)}
                        />
                     </Tooltip>
                  }
               </Space>
            </>
         },
         width: '6%'
      },
   ].filter(item => !item.hidden);

   const assigned_ass_columns_upcoming = [
      {
         title: 'Id',
         key: 'id',
         dataIndex: 'id',
         hidden: true,
      },
      {
         title: 'Allow',
         key: 'allow_result_viewing',
         dataIndex: 'allow_result_viewing',
         hidden: true,
      },

      {
         title: 'Assessment Id',
         key: 'mastery_assessment_id',
         dataIndex: 'mastery_assessment_id',
         hidden: true,
      },
      {
         title: 'Start Date',
         key: 'start_date',
         dataIndex: 'start_date',
         hidden: true,
      },
      {
         title: 'End Date',
         key: 'end_date',
         dataIndex: 'end_date',
         hidden: true,
      },
      {
         title: 'Term',
         dataIndex: 'term',
         key: 'term',
         width: '9%'
      },
      {
         title: 'Subject',
         key: 'subject_desc',
         ...getColumnSearchProps('subject_desc'),
         ellipsis: {
            showTitle: true,
         },
         render: object => (
            <Tooltip placement="topLeft" title={object.subject_desc}>
               <Text>{object.subject_desc}</Text>
            </Tooltip>
         ),
         width: '12%'
      },
      {
         title: 'Code',
         key: 'competency',
         ...getColumnSearchProps('competency'),
         ellipsis: {
            showTitle: true,
         },
         render: object => (
            <Tooltip placement="topLeft" title={object.competency}>
               <Text>{object.competency}</Text>
            </Tooltip>
         ),
         width: '7%'
      },
      {
         title: 'Competency Title',
         key: 'title',
         ...getColumnSearchProps('title'),
         ellipsis: {
            showTitle: true,
         },
         render: object => (
            <Tooltip placement="topLeft"
               title={
                  <>
                     <b>{object.title}</b>
                     <p>{object.start_date + ' - ' + object.end_date}</p>
                  </>
               }
            >
               <div style={{ width: "100%", cursor: "default" }}>
                  <b><Text>{object.title}</Text></b>
                  <p style={{ marginBottom: '0px' }}>{object.start_date + ' - ' + object.end_date}</p>
               </div>
            </Tooltip>
         ),
         width: '44%'
      },

      {
         title: 'Type',
         dataIndex: 'assessment_type',
         key: 'assessment_type',
         width: '7%'
      },
      {
         title: 'Assigned By',
         key: 'assigned_by',
         ...getColumnSearchProps('assigned_by'),
         ellipsis: {
            showTitle: true,
         },
         render: object => (
            <Tooltip placement="topLeft" title={object.assigned_by}>
               <Text>{object.assigned_by}</Text>
            </Tooltip>
         ),
         width: '12%'
      },
   ].filter(item => !item.hidden);

   const getMasteryList = (student_id, subject_id, time_tense) => {
      setListLoading(true);
      axios.get(`${process.env.REACT_APP_API_STUDENT_MASTERY_ASSESSMENT}/listmastery?student_id=${student_id}&subject_id=${subject_id}&time_tense=${time_tense}`).then((response) => {
         console.log(response);

         if (response.data) {
            const data = response.data;

            if (parseInt(time_tense) === 1)
               setCurrentList(data);
            if (parseInt(time_tense) === 2)
               setUpcomingList(data);
            if (parseInt(time_tense) === 3)
               setPastList(data);

            setListLoading(false);
         }
      }, (error) => {
         setListLoading(false);
         console.log(error.message);
      });
   }

   const handleTabChange = (key) => {
      setSubject(0);
      getSubjectCounts(user_id, key);
      getMasteryList(user_id, 0, key);
      setActiveTab(key);
   }

   const handleShowMastery = (assign_id, mastery_id) => {
      var params = { key: ``, value: '' };
      dispatch(reset_mastery_data(params));
      dispatch(reset_mastery_assignment_data(params));

      var assignInfo = null;

      if (activeTab === '1')
         assignInfo = currentList.filter(element => element.id === assign_id)[0];

      if (activeTab === '2')
         assignInfo = upcomingList.filter(element => element.id === assign_id)[0];

      if (activeTab === '3')
         assignInfo = pastList.filter(element => element.id === assign_id)[0];

      dispatch(set_mastery_assignment(assignInfo));

      // navigate('/studentmasteryassessment/preview', {state: {assign_id, mastery_id, assignInfo, origin: activeTab}});
      navigate(`/studentmasteryassessment/preview?assign_id=${assign_id}&mastery_id=${mastery_id}&origin=${activeTab}&qt=${assignInfo.mode}`);
      // navigate(`/studentmasteryassessment/preview?origin=${activeTab}`);
   }

   const handleViewAnswer = (id, assessment_id, q_type, origin, attempts, allow) => {
      var assignInfo = null;

      if (origin === '1')
         assignInfo = currentList.filter(element => element.id === id)[0];
      else
         assignInfo = pastList.filter(element => element.id === id)[0];

      navigate('/studentmasteryassessment/view-result', { state: { assign_id: assignInfo.id, mastery_id: assessment_id, assignInfo, origin: activeTab } });

      // if (allow === 1)
      //    navigate('/studentmasteryassessment/view-result', {state: {assign_id: assignInfo.id, mastery_id: assessment_id, assignInfo}});
      // else {
      //    Modal.error({
      //       content: 'Viewing of exam result is not yet allowed.',
      //       centered: true
      //    });
      // }
   }

   const handleSubjectClick = (subject) => {
      setSubject(subject);
      getMasteryList(user_id, subject, activeTab);
   }

   const RenderSubjectAssignmentCounts = () => {
      const allSubjectsCount = assignedSubjects.reduce((total, item) => total + Number(item.total_counts || 0), 0);

      return (
         <div className="brainee-module-meta mastery-student-subject-filters">
            {assignedSubjects.map(({ id, subject: subjectName, total_counts }) => (
               <span
                  key={id}
                  role="button"
                  tabIndex={0}
                  className={subject === id ? "is-active" : ""}
                  style={{ cursor: total_counts > 0 ? 'pointer' : 'default' }}
                  onClick={() => handleSubjectClick(id)}
                  onKeyDown={(event) => event.key === 'Enter' && handleSubjectClick(id)}
               >
                  <BookOutlined />
                  {subjectName}
                  <strong>{total_counts}</strong>
               </span>
            ))}

            <span
               role="button"
               tabIndex={0}
               className={subject === 0 ? "is-active" : ""}
               style={{ cursor: allSubjectsCount > 0 ? 'pointer' : 'default' }}
               onClick={() => handleSubjectClick(0)}
               onKeyDown={(event) => event.key === 'Enter' && handleSubjectClick(0)}
            >
               <BookOutlined />
               All
               <strong>{allSubjectsCount}</strong>
            </span>
         </div>
      );
   }

   const activeTabLabels = {
      1: "Current",
      2: "Upcoming",
      3: "Past",
   };
   const activeRecordCount = activeTab === "1" ? currentList.length : activeTab === "2" ? upcomingList.length : pastList.length;

   const renderMasterySkeleton = () => (
      <div className="brainee-module-skeleton-table" aria-label="Loading records" role="status" aria-live="polite">
         <div className="brainee-module-skeleton-header">
            <Skeleton.Input active size="small" className="brainee-module-skeleton-title" />
            <Skeleton.Input active size="small" className="brainee-module-skeleton-chip" />
            <Skeleton.Input active size="small" className="brainee-module-skeleton-chip" />
         </div>
         {Array.from({ length: 7 }).map((_, index) => (
            <div className="brainee-module-skeleton-row" key={`mastery-student-assessment-skeleton-${index}`}>
               <Skeleton.Input active size="small" className="brainee-module-skeleton-cell is-wide" />
               <Skeleton.Input active size="small" className="brainee-module-skeleton-cell" />
               <Skeleton.Input active size="small" className="brainee-module-skeleton-cell" />
               <Skeleton.Button active size="small" shape="round" className="brainee-module-skeleton-action" />
            </div>
         ))}
      </div>
   );

   const displayPaneTable = (columns, data) => (
      <>
         {listLoading
            ? renderMasterySkeleton()
            : data.length > 0
               ? (
                  <div className="brainee-module-table-shell">
                     <Table
                        rowKey={'uid'}
                        loading={false}
                        size='small'
                        className="brainee-module-table"
                        columns={columns}
                        dataSource={data}
                        pagination={false}
                        scroll={{
                           x: '1000px',
                           y: 'calc(100vh - 20rem)',
                        }}
                        footer={() => <div className="brainee-module-table-footer">Total Records: {data.length}</div>}
                     />
                  </div>
               )
               : (
                  <div className="brainee-module-state">
                     <Empty image="../images/brainee_mascot.png" description="No records found" />
                  </div>
               )}
      </>
   );

   return (
      <>
         <div className="dashboard-area-all brainee-module-page">
            <div className="dashboard-item brainee-module-shell">
               <div className="brainee-module-breadcrumb">
                  <ResponsiveBreadcrumb
                     style={{ paddingBottom: '15px' }}
                     items={[
                        { key: 'home', node: <Link to="/home">Home</Link> },
                        { key: 'lms', node: 'Brainee LMS' },
                        { key: 'mastery-assessments', node: 'Mastery Assessments' },
                     ]}
                  />
               </div>

               <section className="brainee-module-hero">
                  <div className="brainee-module-hero-copy">
                     <Text className="brainee-module-kicker">Brainee LMS</Text>
                     <h1>Mastery Assessments</h1>
                     <p>Track current mastery work, upcoming activities, and completed assessments in one view.</p>
                     <div className="brainee-module-meta-row">
                        <div className="brainee-module-meta">
                           <span>
                              <DatabaseOutlined />
                              {listLoading ? "Loading records" : `${activeRecordCount} record${activeRecordCount === 1 ? "" : "s"}`}
                           </span>
                           <span>
                              {activeTab === "1" ? <ClockCircleOutlined /> : activeTab === "2" ? <CalendarOutlined /> : <HistoryOutlined />}
                              {activeTabLabels[activeTab]}
                           </span>
                        </div>
                     </div>
                     {assignedSubjects !== null && RenderSubjectAssignmentCounts()}
                  </div>
               </section>

               <section className="brainee-module-panel">
                  <Tabs defaultActiveKey={aTab} activeKey={activeTab} className="brainee-module-tabs" centered onChange={(key) => handleTabChange(key)}>
                     <TabPane
                        tab={(
                           <span className="brainee-module-tab-label"><ClockCircleOutlined /> Current</span>
                        )}
                        key="1"
                     >
                        {displayPaneTable(assigned_ass_columns, currentList)}
                     </TabPane>
                     <TabPane
                        tab={(
                           <span className="brainee-module-tab-label"><CalendarOutlined /> Upcoming</span>
                        )}
                        key="2"
                     >
                        {displayPaneTable(assigned_ass_columns_upcoming, upcomingList)}
                     </TabPane>
                     <TabPane
                        tab={(
                           <span className="brainee-module-tab-label"><HistoryOutlined /> Past</span>
                        )}
                        key="3"
                     >
                        {displayPaneTable(assigned_ass_columns, pastList)}
                     </TabPane>
                  </Tabs>
               </section>
            </div>
         </div>

         {/* <div className="notice-area" style={{ display: "block" }}>
            <div className="notice-item">
               <img src="../images/brainee_ma.png" width="100%" style={{ padding: "5px", maxWidth: '600px' }}></img>
               <NoticeBoard />
            </div>
         </div> */}
      </>
   );
}

